const User = Object.freeze({
	Id: 'id',
	FirstName: 'firstName',
	LastName: 'lastName',
	Username: 'username',
	PhoneWork: 'phoneWork',
	PhoneMobile: 'phoneMobile',
	PhoneOther: 'phoneOther',
	EmailWork: 'emailWork',
	EmailPersonal: 'emailPersonal',
	EmailOther: 'emailOther',
	IsEnabled: 'isEnabled',
	SDSSupportUsername: 'support@streamdata.com',
});

export default User;
